import type { ReactNode } from 'react';
import Button from '@mui/material/Button';
import { BaseDialog } from '@/components/shared/base-dialog';

const defaultActionLabels = {
  cancel: 'Cancelar',
  confirm: 'Confirmar',
};

export interface ConfirmDialogProps {
  actionLabels?: {
    cancel?: string;
    confirm?: string;
  };
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg';
  children: ReactNode;
  disableConfirmButton?: boolean;
  disableCloseButton?: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title?: string | ReactNode;
  open?: boolean;
}

interface ActionsProps {
  disableCloseButton: boolean;
  onClose: () => void;
  actionLabels: {
    cancel?: string;
    confirm?: string;
  };
  disableConfirmButton: boolean;
  onConfirm: () => void;
}

const Actions = ({
  disableCloseButton,
  onClose,
  actionLabels,
  disableConfirmButton,
  onConfirm,
}: ActionsProps) => {
  return (
    <>
      <Button disabled={disableCloseButton} onClick={onClose} variant="text">
        {actionLabels.cancel}
      </Button>
      <Button
        disabled={disableConfirmButton}
        onClick={onConfirm}
        variant="contained"
      >
        {actionLabels.confirm}
      </Button>
    </>
  );
};

export const ConfirmDialog = ({
  actionLabels = {
    cancel: defaultActionLabels.cancel,
    confirm: defaultActionLabels.confirm,
  },
  children,
  disableConfirmButton = false,
  disableCloseButton = false,
  onClose,
  onConfirm,
  title,
  open = false,
  maxWidth = 'sm',
}: ConfirmDialogProps) => {
  return (
    <BaseDialog
      actionsComponent={
        <Actions
          disableCloseButton={disableCloseButton}
          onClose={onClose}
          actionLabels={actionLabels}
          disableConfirmButton={disableConfirmButton}
          onConfirm={onConfirm}
        />
      }
      onClose={disableCloseButton ? undefined : onClose}
      open={open}
      title={title}
      maxWidth={maxWidth}
    >
      {children}
    </BaseDialog>
  );
};
